export const workingIndicatorMessages = {
  text: {
    working: {
      id: 'workingIndicator.Text.Working',
      defaultMessage: 'Working...',
    },
  },
};
